import React, { FunctionComponent } from "react";
import styled from "styled-components";
import theme from "../theme";

const Wrapper = styled.p`
  margin: 0 0 ${theme.unit}px 0;
  font-size: ${theme.fonts.medium.fontSize};
  line-height: ${theme.fonts.medium.lineHeight};
`;

const Paragraph: FunctionComponent = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Paragraph;
